/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import QuestionPage from './views/QuestionPage'
import { withStyles } from '@material-ui/core/styles/index'
import ReactGA from 'react-ga'
import Cookies from 'universal-cookie'
import './index.css'
import { styles } from './index.styles'
import Alert from './components/Alert'
import Terms from './views/partials/Terms'
import PageHeader from './views/partials/PageHeader'
import Disclaimer from './views/partials/Disclaimer'
import { next } from '../api'
import QuestionPageWrapper from './views/QuestionPageWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InfoCards from './views/partials/InfoCards'

import { Box, Paper, Grid } from '@material-ui/core'
import Footer from './views/partials/Footer'
import i18n from 'i18next'

ReactGA.initialize(process.env.MIX_APP_ENV == 'local' ? '' : process.env.MIX_GA_TRACKING_CODE, { debug: false })

class QuestionApplication extends PureComponent {
    constructor(props) {
        super(props)
        this.questionPage = React.createRef()
    }

    state = {
        questionContainerId: process.env.MIX_DEFAULT_QUESTION_CONTAINER_ID,
        questionPage: null,
        value: 'recents',
        progress: 30,
        iframeRefreshKey: 0,
        isLoading: true,
        pageAlias: '',
        alert: null,
        prelanderCompleted: false,
        vc: null,
        conversionTestKey: null,
        conversionTestAvailable: true,
        theme: null
    }

    componentDidMount() {
        if (this.props.data && this.props.data.questionPage) {
            this.setQuestionPageState(this.props.data)
        } else {
            if (this.props.data && this.props.data.conversionTestExperimentKey) {
                this.startConversionTest()
            } else {
                this.start()
            }
        }
    }

    async startConversionTest() {
        if (window.dataLayer) {
            await window.dataLayer.push({ event: 'optimize.activate' })
        }
        let tryCount = 1
        this.intervalId = setInterval(() => {
            if (window.google_optimize !== undefined) {
                const experimentKey = this.props.data.conversionTestExperimentKey
                const variantKey = window.google_optimize.get(experimentKey)
                this.setState({ conversionTestKey: experimentKey + '|' + variantKey }, () => {
                    this.start()
                })
                clearInterval(this.intervalId)
            }
            tryCount++

            if (tryCount > 10) {
                clearInterval(this.intervalId)
                this.start()
            }
        }, 100)
    }

    start = () => {
        this.onNext(this.props.data ? this.props.data.answers : null, false, this.props.data ? this.props.data.skip : null)
    }

    onNext = (answers = [], previous = false, skip = null) => {
        ReactGA.event({
            category: 'Process',
            action: 'Submitted',
            label: this.state.pageAlias
        })
        this.setState({ isLoading: true })

        const questionContainerId = this.props.data.questionContainerId ? this.props.data.questionContainerId : this.state.questionContainerId

        next(
            questionContainerId,
            answers,
            this.state.questionPage ? this.state.questionPage.id : null,
            this.state.visitorSessionId,
            !previous ? 1 : -1,
            skip,
            this.props.layout,
            this.props.data.affiliateTag ? this.props.data.affiliateTag : null,
            this.props.theme ? this.props.theme.id : null,
            this.state.conversionTestKey,
            this.props.data.prea,
            this.props.data.p,
            this.props.data.lang
        ).then(data => {
            this.setQuestionPageState(data)
        })
    }

    previous = () => {
        ReactGA.event({
            category: 'QuestionPage',
            action: 'Previous',
            label: this.state.pageAlias
        })
        this.setState({ isLoading: true })
        next(this.state.questionContainerId, [], this.state.questionPage.id, this.state.visitorSessionId, -1).then(data => {
            this.setQuestionPageState(data)
        })
    }

    setQuestionPageState(data) {
        if (data.questionPage && data.questionPage.redirectUrl) {
            window.location = data.questionPage.redirectUrl
            return
        }

        const lang = data.session && data.session.visitorSession && data.session.visitorSession.language ? data.session.visitorSession.language : null
        if (lang) {
            i18n.changeLanguage(lang)
        }

        this.setState({
            questionContainerId: data.questionContainerId ? data.questionContainerId : this.state.questionContainerId,
            surveyAlias: data.surveyAlias,
            themeAlias: data.themeAlias,
            affiliateTag: data.affiliateTag,
            questionPage: data.questionPage,
            surveyId: data.surveyId,
            campaignId: data.campaignId,
            pageAlias: data.pageAlias,
            visitorSessionId: data.visitorSessionId,
            formHash: data.formHash,
            iframeRefreshKey: this.state.iframeRefreshKey + 1,
            isLoading: false,
            alert: data.alert,
            hasPixels: data.hasPixels,
            vc: data.vc,
            scorings: data.scorings,
            theme: data.session && data.session.platform ? data.session.platform : null
        })

        if (data.cookie) {
            const cookies = new Cookies()
            cookies.set(data.cookie.name, data.cookie.value, {
                path: '/',
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 5))
            })
        }

        const url = '/process/' + data.pageAlias
        //this.trackPageview(url)

        const alert = data.alert
    }

    trackPageview(url) {
        ReactGA.set({ page: url })
        ReactGA.pageview(url)
        if (url === '/c/signup/yhteystietosivu1') {
            window.dataLayer.push({ event: 'optimize.activateTest1' })
        }

        if (url === '/process/result-page') {
            try {
                fbq('track', 'SubmitApplication')
            } catch (error) {}
        }
    }

    onAlertClose = () => {
        this.setState({ alert: null })
    }

    onPrelanderCompleted = () => {
        this.setState({ prelanderCompleted: true })
    }

    childNext = () => {
        this.questionPage.current.onSubmit()
    }

    childPrev = () => {
        this.questionPage.current.onSubmit(true)
    }

    render() {
        const { classes, layout, minHeight } = this.props

        const { questionPage, activeStep, isLoading, pageAlias, prelanderCompleted, visitorSessionId } = this.state

        const theme = this.state.theme ?? this.props.theme

        return (
            <>
                {layout === 'full' && (
                    <div className={classes.root} key={'questionApp'}>
                        <PageHeader questionPage={questionPage} />
                        <Grid container className={classes.container}>
                            <Grid item xs={12} sm={8}>
                                <Paper className={'questionApp-wrapper ' + classes.wrapper + ' ' + classes.paper} elevation={1}>
                                    {!questionPage && (
                                        <div className={classes.loaderWrapper}>
                                            <FontAwesomeIcon size="2x" icon={['far', 'spinner-third']} spin className={classes.loadingSpinner} />
                                        </div>
                                    )}
                                    {questionPage && (
                                        <QuestionPageWrapper
                                            questionPage={questionPage}
                                            questionPageRef={this.questionPage}
                                            pageAlias={pageAlias}
                                            isLoading={isLoading}
                                            activeStep={activeStep}
                                            onNext={this.onNext}
                                            childNext={this.childNext}
                                            childPrev={this.childPrev}
                                            visitorSessionId={visitorSessionId}
                                            theme={theme}
                                        />
                                    )}
                                </Paper>
                                {questionPage && <Disclaimer content={theme.disclaimer ?? ''} />}
                                {questionPage && questionPage.termsPosition === 'below' && <Terms theme={theme} />}
                            </Grid>
                            {questionPage && questionPage.infoCards && (
                                <Grid item xs={12} sm={4} className={classes.hideOnMobile + ' ' + classes.infoCardWrapper}>
                                    <InfoCards infoCards={questionPage.infoCards} theme={theme} />
                                </Grid>
                            )}
                        </Grid>
                    </div>
                )}
                {layout === 'center' && (
                    <div className={classes.root + ' ' + classes.rootCenter + ' questionApplicationRoot'} key={'questionApp'}>
                        <Grid container className={classes.containerCenter + ' questionApplicationContainer'}>
                            <Grid item xs={12}>
                                <Paper className={'questionApp-wrapper ' + classes.wrapper + ' ' + classes.paper} elevation={1}>
                                    {theme?.logo && (
                                        <Box
                                            className={'primary-content-img-wrapper primary-content-img-wrapper-question-page-id-' + questionPage?.id}
                                        >
                                            <img src={theme.logo} />
                                        </Box>
                                    )}
                                    {!questionPage && (
                                        <div className={classes.loaderWrapper}>
                                            <FontAwesomeIcon size="2x" icon={['far', 'spinner-third']} spin className={classes.loadingSpinner} />
                                        </div>
                                    )}
                                    {questionPage && (
                                        <QuestionPageWrapper
                                            questionPage={questionPage}
                                            questionPageRef={this.questionPage}
                                            pageAlias={pageAlias}
                                            isLoading={isLoading}
                                            activeStep={activeStep}
                                            onNext={this.onNext}
                                            childNext={this.childNext}
                                            childPrev={this.childPrev}
                                            visitorSessionId={visitorSessionId}
                                            theme={theme}
                                        />
                                    )}
                                </Paper>
                                {questionPage && <Disclaimer content={theme.disclaimer ?? ''} />}
                                {questionPage && questionPage.termsPosition === 'below' && <Terms theme={theme} />}
                            </Grid>
                        </Grid>
                    </div>
                )}
                {layout === 'content' && questionPage && (
                    <div className={classes.wrapper} style={{ minHeight: minHeight }}>
                        <QuestionPageWrapper
                            questionPage={questionPage}
                            questionPageRef={this.questionPage}
                            pageAlias={pageAlias}
                            isLoading={isLoading}
                            prelanderCompleted={prelanderCompleted}
                            activeStep={activeStep}
                            onPrelanderCompleted={this.onPrelanderCompleted}
                            onNext={this.onNext}
                            childNext={this.childNext}
                            childPrev={this.childPrev}
                            visitorSessionId={visitorSessionId}
                            theme={theme}
                        />
                    </div>
                )}
                {this.state.alert && <Alert alert={this.state.alert} onClose={this.onAlertClose} />}
                {this.state.hasPixels && (
                    <iframe
                        src={process.env.MIX_API_URL + '/pixels?vs=' + visitorSessionId}
                        key={this.state.iframeRefreshKey}
                        style={{
                            width: 0,
                            height: 0,
                            border: 'none',
                            position: 'absolute'
                        }}
                    />
                )}
                {false && !theme?.isEmbedded && theme?.domain === 'hae.rahoo.fi' && <Footer />}
            </>
        )
    }
}

export default withStyles(styles)(QuestionApplication)
